import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { LoadingScreen } from '../components/LoadingScreen';

const DashboardRedirect = () => {
  const { account, loading } = useAuth();

  if (loading) {
    return (
      <LoadingScreen label="Loading…" />
    );
  }

  if (!account) return <Navigate to="/login" replace />;
  if (account.role === 'super_admin') return <Navigate to="/super" replace />;
  return <Navigate to="/admin" replace />;
};

export default DashboardRedirect;
